
import React from 'react';

const MouseClickUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M16.878 25.772h-.04c-.41-.02-.78-.29-.91-.68l-5-15c-.11-.36-.02-.76.25-1.02.26-.27.66-.37 1.02-.25l15 5c.39.13.67.49.68.91.02.41-.22.8-.61.96l-6.63 2.84-2.84 6.63c-.16.38-.52.61-.92.61zm-3.42-14.42l3.54 10.61 1.96-4.58c.1-.24.29-.42.53-.52l4.58-1.96-10.61-3.55z'
			></path>
			<path
				fill='#2d2d2d'
				d='M22.583 19.067L21.17 20.48l4.002 4.002 1.414-1.414-4.002-4.002zM9.748 2.002L7.9 2.769l1.15 2.77 1.848-.766-1.15-2.771zM18.89 5.792l-2.77 1.151.767 1.847 2.77-1.151-.767-1.847zM6.88 10.772l-2.77 1.151.768 1.847 2.77-1.151-.768-1.847zM14.03 2l-1.15 2.771 1.848.767 1.15-2.772L14.03 2zM9.05 14.01l-1.149 2.771 1.847.767 1.15-2.772-1.847-.766zM4.878 5.79L4.11 7.639l2.77 1.15.767-1.847-2.77-1.15zM26.878 30h-20v2h20v-2z'
			></path>
		</svg>
	);
};

export default MouseClickUnderline;
